export const PRODUCT_DESCRIPTION_MAX_LENGTH = 220

export function normalizeProductDescription(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const cleaned = value.replace(/\s+/g, ' ').trim()
  if (!cleaned || cleaned.length > PRODUCT_DESCRIPTION_MAX_LENGTH) return null
  return cleaned
}
